(function(){
  var $=function(id){return document.getElementById(id);};
  if(!$('slrN')) return;
  var F=['slrN','slrWo','slrWn','slrH','slrD','slrP'];
  var nf=new Intl.NumberFormat('fr-FR');
  var CO2=0.060;

  function val(id,min){ var v=parseFloat(($(id).value||'').replace(',','.')); return (isFinite(v)&&v>=min)?v:0; }

  function calc(){
    var n=val('slrN',1), wo=val('slrWo',1), wn=val('slrWn',0),
        h=val('slrH',0.1), d=val('slrD',1), p=val('slrP',0.01);
    var H=h*d, kOld=wo*n/1000*H, kNew=wn*n/1000*H;
    var dk=Math.max(0,kOld-kNew), eco=dk*p, pct=kOld>0?Math.round(dk/kOld*100):0;
    $('slrEco').textContent=nf.format(Math.round(eco));
    $('slrPct').textContent='soit '+pct+' % de votre consommation d\u2019\u00e9clairage';
    $('slrK').textContent=nf.format(Math.round(dk));
    $('slrC').textContent=nf.format(Math.round(dk*CO2));
    $('slr5').textContent=nf.format(Math.round(eco*5))+' \u20ac';
    $('slrKW').textContent=nf.format(Math.round((wo-wn)*n/1000*10)/10)+' kW';
    $('slrStkVal').textContent=nf.format(Math.round(eco))+' \u20ac/an';
    window.SL_EXPRESS={points:n,w_actuel:wo,w_led:wn,heures:h,jours:d,prix_kwh:p,eco_an:Math.round(eco)};
  }

  F.forEach(function(id){ $(id).addEventListener('input',calc); });

  Array.prototype.forEach.call(document.querySelectorAll('.slr-preset'),function(b){
    b.addEventListener('click',function(){
      Array.prototype.forEach.call(document.querySelectorAll('.slr-preset'),function(o){o.setAttribute('aria-pressed','false');});
      b.setAttribute('aria-pressed','true');
      var v=b.getAttribute('data-p').split(',');
      ['slrN','slrWo','slrWn','slrH','slrD'].forEach(function(id,i){ $(id).value=v[i]; });
      calc();
      try{(window.dataLayer=window.dataLayer||[]).push({event:'relamp_preset',preset:b.textContent.trim()});}catch(e){}
    });
  });

  function show(which){
    var x=(which==='x');
    $('slrTabX').setAttribute('aria-selected',x?'true':'false');
    $('slrTabE').setAttribute('aria-selected',x?'false':'true');
    $('slrPanX').hidden=!x; $('slrPanE').hidden=x;
  }
  $('slrTabX').addEventListener('click',function(){show('x');});
  $('slrTabE').addEventListener('click',function(){show('e');});

  function toEtude(){
    show('e');
    try{(window.dataLayer=window.dataLayer||[]).push({event:'relamp_switch_etude',eco_express:(window.SL_EXPRESS||{}).eco_an});}catch(e){}
    if(typeof window.SL_PREFILL==='function'){ try{ window.SL_PREFILL(window.SL_EXPRESS); }catch(e){} }
    $('slrOutil').scrollIntoView({behavior:'smooth',block:'start'});
  }
  ['slrGo','slrGo2','slrStkBtn'].forEach(function(id){ if($(id)) $(id).addEventListener('click',toEtude); });

  var tool=$('slrOutil'), stk=$('slrSticky');
  if(tool&&stk&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){
      stk.classList.toggle('on', !e[0].isIntersecting && e[0].boundingClientRect.top<0);
    },{threshold:0}).observe(tool);
  }

  calc();
})();